/* eslint array-callback-return: 0*/

import React, { Component } from 'react';

 
import { connect } from 'react-redux';

import { fetchProducts, showProduct } from '../../actions/product';
import * as uri from '../../config/uri';

import { setProduct } from '../../actions/product';
import { fetchByCategory, setCurrentCategoryIndex, setActiveCategoryIndex } from '../../actions/api';

import { getCategoryNames } from '../../reducers/configReducer';

import ProductContainerRender from "../ProductContainerRender/ProductContainerRender";
import { nextPage } from '../../actions/lazyload';
import { getCategories } from '../../selectors/configSelectors';

class ProductContainer extends Component {
  getCategoryParam = () => {
      return this.props.match.params.category;
  }
 
  componentDidMount() {
    if (this.props.holdProduct) return;
    let catName = this.getCategoryParam();
    const allowed = this.props.allowedCategories.indexOf(catName.toUpperCase()) !== -1;
    if (!allowed)  {
      this.props.go(uri.rootPageUri);
      return;
    }
    this.setCategoryAndFetch(catName);
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.match.params.category !== nextProps.match.params.category) {
      const catName = nextProps.match.params.category;
      this.setCategoryAndFetch(catName);
    }
  }

  setCategoryAndFetch = (catName) => {
    let catIdx;
    this.props.categories.map((item, index) => {
      if (item.name === catName.toUpperCase()) catIdx = index;
    });
    this.props.setActiveCatIdx(catIdx);
    if (catName) {
      this.props.fetchByCategory(catName);
      // todo: set 1st page
      this.props.setNextPage();
    } else {
      this.props.go(uri.rootPageUri);
    }
  }

  render() {
    return <ProductContainerRender/>;
  }
}

const mapStateToProps = (state) => {
  return {
    router : state.router,
    categories: getCategories(state),
    view: state.view,
    catIdx: state.products.activeCategoryIndex,
    holdProduct: state.holdProduct,
    allowedCategories: getCategoryNames(state)
  };
};

const mapDispatchToProps = (dispatch) => {
  return { 
      fetchByCategory: (name)=> dispatch(fetchByCategory(name, 0, 20)),
      setCurrentCatIdx: (idx) => dispatch(setCurrentCategoryIndex(idx)),
      go: (path) => dispatch(pushWithQueryParams(path)),
      showProduct: (index) => dispatch(showProduct(index)),
      fetchProducts: () => dispatch(fetchProducts()),
      setCurrentProduct: (product) => dispatch(setProduct(product)),
      setActiveCatIdx: (idx) => dispatch(setActiveCategoryIndex(idx)),
      setNextPage: () => dispatch(nextPage()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductContainer);



// WEBPACK FOOTER //
// ./src/components/ProductContainerCategory/ProductContainerCategory.jsx